<div class="paginator">
  <div class="paginator--prev" [class]="{'disabled': !pagination?.previous}"><a href="#" (click)="goToPrev(pagination)"><mat-icon>arrow_back_ios</mat-icon></a></div>
  <div class="paginator--infos">{{ pagination.start }} - {{(pagination.start + pagination.nb_items)-1}} / {{pagination.total}}</div>
  <div class="paginator--next" [class]="{'disabled': !pagination?.next}"><a href="#" (click)="goToNext(pagination)"><mat-icon>arrow_forward_ios</mat-icon></a></div>
</div>
